import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { ToastModule } from 'primeng/toast';
import { DividerModule } from 'primeng/divider';
import { MessageService } from 'primeng/api';
import { NGXLogger } from 'ngx-logger';
import { Richiesta } from '../../../models/richiesta.model';
import { RichiesteService } from '../../../services/richieste.service';
import { StiliService } from '../../../services/stili.service';

@Component({
  selector: 'app-conferma-finanziamento',
  templateUrl: './conferma-finanziamento.component.html',
  styleUrls: ['./conferma-finanziamento.component.css'],
  standalone: true,
  imports: [
    CommonModule,
    DialogModule,
    ButtonModule,
    ToastModule,
    DividerModule
  ],
  providers: [MessageService]
})
export class ConfermaFinanziamentoComponent implements OnInit {
  @Input() visible: boolean = false;
  @Input() richiesta: Richiesta | null = null;
  @Output() visibleChange = new EventEmitter<boolean>();
  @Output() finanziamentoConfermato = new EventEmitter<void>();

  finanziamentoInCorso: boolean = false;

  constructor(
    private messageService: MessageService,
    private logger: NGXLogger,
    private richiesteService: RichiesteService,
    public stiliService: StiliService
  ) { }

  ngOnInit(): void {
  }

  hide() {
    this.visible = false;
    this.visibleChange.emit(false);
  }

  confermaFinanziamento() {
    if (!this.richiesta) return;

    this.finanziamentoInCorso = true;
    this.logger.info('[CONFERMA FINANZIAMENTO] Avvio conferma finanziamento', this.richiesta);

    this.richiesteService.finanziaRichiesta(this.richiesta.id).subscribe({
      next: () => {
        this.logger.info('[CONFERMA FINANZIAMENTO] Finanziamento confermato con successo');
        this.messageService.add({
          severity: 'success',
          summary: 'Finanziamento richiesta ' + this.richiesta?.anno,
          detail: 'Finanziamento confermato con successo'
        });
        this.finanziamentoConfermato.emit();
        this.hide();
      },
      error: (error: Error) => {
        this.logger.error('[CONFERMA FINANZIAMENTO] Errore durante la conferma del finanziamento', error);
        this.messageService.add({
          severity: 'error',
          summary: 'Errore',
          detail: 'Si è verificato un errore durante la conferma del finanziamento'
        });
      },
      complete: () => {
        this.finanziamentoInCorso = false;
      }
    });
  }

  show(richiesta: Richiesta) {
    this.richiesta = richiesta;
    this.visible = true;
  }
}
